import type { CreatorPlaybackEvent } from './CreatorSession.types';

export class CreatorSessionEventQueue {
    private eventQueue: CreatorPlaybackEvent[] = [];

    public add = (event: CreatorPlaybackEvent): void => {
        let insertIndex = this.eventQueue.findIndex(
            (value) => event.time <= value.time,
        );

        insertIndex = insertIndex < 0 ? this.eventQueue.length : insertIndex;

        this.eventQueue.splice(insertIndex, 0, event);
    };

    public getEventsInFrame = (time: number): CreatorPlaybackEvent[] => {
        const spliceIndex = this.eventQueue.findIndex(
            (value) => time > value.time,
        );

        if (spliceIndex === -1) {
            return [];
        }

        return this.eventQueue.splice(0, spliceIndex + 1);
    };

    public reset = (): void => {
        this.eventQueue = [];
    };
}
